import { writable } from 'svelte/store'
import {
  hexToRgbString,
  extractRGB,
  hexWithOpacity,
  rgbStringToHex,
  isValidRgbString,
  isValidHexString,
  isValidOpacityValue,
  getHexfOpacity
} from './helpers'

function selectedColor() {
  const { subscribe, set } = writable({
    rgba: 'rgba(0, 0, 0, 1)',
    rgb: 'rgb(0, 0, 0)',
    hex: '#000000',
    hexF: '#000000ff',
    r: 0,
    g: 0,
    b: 0,
    a: 1,
    opacity: 100
  })

  return {
    subscribe,
    set,
    change: (value, currentStore) => {
      const valueKey = Object.keys(value)[0]

      if (valueKey === 'hex' || valueKey === 'hexF') {
        const hexValue = valueKey === 'hex' ? value.hex : value.hexF?.slice(0, 7)
        if (!isValidHexString(hexValue)) return null

        const opacity = valueKey === 'hex' ? currentStore.opacity : getHexfOpacity(value.hexF)

        const rgbString = hexToRgbString(hexValue)
        const rgbValues = extractRGB(rgbString, opacity)
        const hexF = hexWithOpacity(hexValue, opacity)

        set({ ...rgbValues, hex: hexValue, opacity, hexF })
      } else if (valueKey === 'rgb') {
        const rgbString = value.rgb
        if (!isValidRgbString(rgbString)) return null

        const opacity = currentStore.opacity

        const hexValue = rgbStringToHex(rgbString)
        const rgbValues = extractRGB(rgbString, opacity)

        const hexF = hexWithOpacity(hexValue, opacity)

        set({ ...rgbValues, hex: hexValue, opacity, hexF })
      } else if (valueKey === 'opacity') {
        const opacity = value.opacity
        if (!isValidOpacityValue(opacity)) return null

        const rgbValues = extractRGB(currentStore.rgb, opacity)
        const hexF = hexWithOpacity(currentStore.hex, opacity)

        set({ ...rgbValues, hex: currentStore.hex, opacity, hexF })
      }
    }
  }
}

export default selectedColor
